import { render, staticRenderFns } from "./RqtaList.vue?vue&type=template&id=868d0c8c&scoped=true&"
import script from "./RqtaList.vue?vue&type=script&lang=js&"
export * from "./RqtaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868d0c8c",
  null
  
)

export default component.exports